import Morphism, { Schema as MappingSchema } from 'morphism';
import { Constructable } from '@ervo/page-framework';

export function MapFrom<TSource, TTarget>(
  schema: MappingSchema<TTarget, TSource>
): (target: Constructable<TTarget>) => void {
  return (target: Constructable<TTarget>) => {
    Morphism.register(target as Constructable<any>, schema);
  };
}
